<template>
  <div id="sovdetailed" style="text-transform: capitalize;">
    <div data-html2canvas-ignore="true" v-show="loader">
      <Loader />
    </div>
  	<div class="datepickerwrap card revampCard"
    style="flex-direction:row; margin-bottom: 1.5rem;">
  		<div class="leftcontent wrapitem">
  			<div class="datebox" v-show='false'>
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate2" />
  	 		</div>
        <div class="datebox customSelect">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  			
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<optgroup label="Retail" v-show='false'>
              <option value="all">All</option>
              <option value="https://www.amazon.com">Amazon US</option>
              <option value="https://www.amazon.fr">Amazon France</option>
              <option value="https://www.amazon.co.it">Amazon Italy</option>
              <option value="https://www.amazon.es">Amazon Spain</option>
              <option value="https://www.amazon.co.uk">Amazon UK</option>
              <option value="https://www.amazon.de">Amazon Germany</option>
              <option value="https://www.bestbuy.com">Best Buy US</option>
              <option value="https://www.costco.com">Costco US</option>
              <option value="https://www.currys.co.uk">Curry's UK</option>
              <option value="https://www.harveynorman.com.au">Harvey Norman AU</option>  
              <option value="https://global.jd.com">JD GC</option>
              <option value="https://www.mediamarkt.de">MediaMarkt DE</option>
              <option value="https://www.walmart.com">Walmart US</option>
            </optgroup>
            <optgroup label="Consumer OEM">
              <option value="https://br-store.acer.com">Acer Brazil</option>
              <option value="https://store.acer.com/en-us">Acer US</option>
            	<option value="https://www.asus.com/fr">ASUS France</option>
            	<option value="https://store.asus.com/us">ASUS US</option>
              <option value="https://www.dell.com/en-au">Dell Australia</option>
              <option value="https://www.dell.com/ja-jp">Dell Japan</option>
              <option value="https://www.dell.com/en-us">Dell US</option>
              <option value="https://www.dell.com/en-uk">Dell UK</option>
              <option value="https://fmv.fccl.fujitsu.com">Fujitsu Japan</option>
              <option value="https://store.hp.com/FranceStore">HP France</option>
              <option value="https://www8.hp.com/jp">HP Japan</option>
              <option value="https://store.hp.com/mx-es">HP Mexico</option>
              <option value="https://store.hp.com/UKStore">HP UK</option>
              <option value="https://store.hp.com/us">HP US</option>
              <option value="https://www.lenovo.com/au">Lenovo Australia</option>
              <option value="https://s.lenovo.com.cn">Lenovo China</option>
              <option value="https://www.lenovo.com/fr">Lenovo France</option>
              <option value="https://www.lenovo.com/de">Lenovo Germany</option>
              <option value="https://www.lenovo.com/gb">Lenovo UK</option>
              <option value="https://www.lenovo.com/us">Lenovo US</option>
              <option value="https://www.nec-lavie.jp">NEC Japan</option>
            </optgroup>
            <optgroup label="Commercial OEM" >
              <option value="https://www.hpstore.cn#commercial">Commercial HP China</option>
              <option value="https://store.hp.com/FranceStore#commercial">Commercial HP France</option>
              <option value="https://store.hp.com/GermanyStore#commercial">Commercial HP Germany</option>
              <option value="https://www8.hp.com/jp#commercial">Commercial HP Japan</option>
              <option value="https://store.hp.com/UKStore#commercial">Commercial HP UK</option>
              <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
              <option value="https://b2b.lenovo.com.cn#commercial">Commercial Lenovo China</option>
              <option value="https://www.lenovo.com/fr#commercial">Commercial Lenovo France</option>
              <option value="https://www.lenovo.com/de#commercial">Commercial Lenovo Germany</option>
              <option value="https://www.lenovo.com/jp#commercial">Commercial Lenovo Japan</option>
              <option value="https://www.lenovo.com/gb#commercial">Commercial Lenovo UK</option>
              <option value="https://www.lenovo.com/us#commercial">Commercial Lenovo US</option>
            </optgroup>
            <optgroup label="Commercial Reseller" >
              <option value="https://www.bechtle.com">Bechtle</option>
              <option value="https://www.cdw.com">CDW</option>
              <option value="https://www.inmac-wstore.com">Inmac</option>
              <option value="https://www.insight.com/en-US">Insight</option>
              <option value="https://www.connection.com">PC Connection</option>
              <option value="https://www.shi.com">SHI</option>
              <option value="https://www.technoworld.com">TechnoWorld</option>
              <option value="https://www.dustin.no">Dustin Nordics Norway</option>
              <option value="https://www.dustin.se">Dustin Nordics Sweden </option>
              <option value="https://www.dustin.fi">Dustin Nordics Finland </option>
              <option value="https://www.dustin.dk">Dustin Nordics Denmark </option>
            </optgroup>
          </select>
        </div>
        <div class="datebox customSelect" style="width:10%">
          <select v-model="device" @change="refresh"  class="form-control text-uppercase">
            <option value="laptop">Laptop</option>
            <option value="desktop">Desktop</option>
            <option v-if="selected_website== 'https://www.lenovo.com/us#commercial' || selected_website == 'https://store.hp.com/GermanyStore#commercial' || selected_website=='https://store.hp.com/us#commercial' " value="neither">Neither</option>
          </select>
        </div>
          <div class="datebox" style="width:fit-content">
            <button @click="refresh" class="btn primarycolor" type="button">
              Submit
            </button>
          </div>
          <div class="datebox" style="width:fit-content"> 
            <button  @click="exportNow" class="btn primarycolor" ><span>Export</span></button>
          </div>
          <div class="datebox" style="width:fit-content">
            <button @click="goToSOVDetailReport" class="btn navigationButton" ><span>SOV Detail Report</span></button>
          </div>
  	 	</div>
      <div class="righcontent wrapitem">
        <div class="datebox" style="float:right">
          <button @click="backToSov" style="width:max-content;float:right" class="navigationButton" type="button">
            <img src="Icons_SVG/Arrow_Left.svg" height="14" class="backIcon">
            <span> Back</span>
          </button>
        </div>
      </div>
     
  	</div>
    <div class="container-fluid ">
      <!-- <div  style="display: flow-root;">
        <button  style="margin-bottom:10px" class="weavrpurple" @click="filterAddAction" v-if="!addFilter">Add Filter</button>
         <button @click="exportNow" style="margin-bottom:10px;float:right" class="weavrpurple" >Export</button>
      </div> -->
      <!-- <div v-if="addFilter" class="card p-2 filter" style="padding: 21px!important;background: #f5f5f5">
        <div class="row mt-2" v-for="(d,i) in filterRow">
          <div class="col-md-2 pr-0">
            <select v-model="d.filterKey" class="form-control text-uppercase">
             <option value="price">Price</option>
             <option value="reviews">Reviews</option>
             <option value="ratings">Ratings</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
            <select v-model="d.filterCondition" class="form-control text-uppercase">
              <option value="equals">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
           <input v-model="d.val1" class="form-control filval" type="text" placeholder="">
           <input v-if="d.filterCondition == 'between'" v-model="d.val2" class="form-control filval mt-2" type="text" placeholder="">
          </div>
       
          <div  class="col-md-2">
            <button @click="filterRemove(i)" class="btn filval btn-danger"> Remove </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 pt-4" style="text-align: center;">
            <button @click="filterApply" class="btn filval btn-primary mr-2">Apply Filter</button>
            <button v-if="filterRow.length < 3" @click="filterAddMore" class="btn filval btn-success mr-2"> Add more </button>
            <button class="btn filval btn-danger " @click="filterCancel"> Cancel </button>
          </div>
          
        </div>
      </div> -->
      <div class="">
        <div class="card p-2 revampCard">
         
          <table id="amdglobal-sov-detail-newTable" class="table">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                <th v-if="user == 'admin'">Action</th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                  <th v-if="user == 'admin'" ></th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in rows_details"  :key="i" :class="{'markitamd':r['processor'] == 'amd',
                'markitintel':r['processor'] == 'intel','markitsnap':r['processor'] == 'qualcomm snapdragon','markitna':r['processor'] == 'N/A',
                'markittek':r['processor'] == 'mediatek'}">
                <td :data-order="getDataOrder(r[d.field])" v-for="d in columns_details" :key="d.field" > 
                  <div v-if="isDataEditable && selectedItemID == i">
                    <input type="text" class="form-control form-control-sm" id="inputValue" :placeholder="d.label" v-model='editedTableData[d.field]' />
                  </div>
                  <div v-else>
                    <span v-if="d.field == 'product_name'">
                      <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                    </span>
                    <span v-else>
                      <span v-if="r[d.field] != ''">
                        <span v-if="d.field == 'processor' && r['processor']== 'amd' ">{{r[d.field].toUpperCase() }}</span>  
                        <span v-else>{{r[d.field]}}</span>
                      </span>
                      <span v-else>-</span>  
                    </span>
                  </div>
                </td>
                <td v-if="user == 'admin'">
                  <!-- <button type="button" class="form_button btn btn-secondary btn-sm mb-1" @click="processEditDataForm(r)" >Config</button> -->
                  <div class="row" style="width: 90px; margin: 0 auto; display: flex; justify-content: center;">
                    <button type="button" class="form_button btn btn-secondary btn-sm" @click="processEditableTableData(r, i)" >Edit</button>
                    <button v-if="isDataEditable && selectedItemID == i" class="form_button btn btn-primary btn-sm ml-1" @click="postEditedTableData(i)">Save</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table> 
        </div> 
        <!-- <div style="height: 80px"></div>   -->
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Loader from "./Components/Loader.vue"

export default {
  name: 'sovdetailed',
  components: { Datepicker, Loader },
  watch: {
    selected_website(){
      this.device='laptop'
    }
  },
  data: function () {
    return {
    	selected_website:localStorage.selected_SOVWebsite,
      device:'laptop',
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD'),
        startDate2: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      oem_websites:['https://www.inmac-wstore.com','https://www.technoworld.com','https://www.bechtle.com','https://www.connection.com',"https://www.dustin.no", "https://www.dustin.se", "https://www.dustin.fi","https://www.dustin.dk",'https://www.shi.com','https://www8.hp.com/jp#commercial','https://www.lenovo.com/jp#commercial','https://b2b.lenovo.com.cn#commercial','https://www.hpstore.cn#commercial','https://www.nec-lavie.jp','https://fmv.fccl.fujitsu.com','https://www.dell.com/ja-jp','https://www.dell.com/en-uk','https://www.dell.com/en-au','https://www.lenovo.com/au','https://br-store.acer.com','https://s.lenovo.com.cn','https://store.hp.com/FranceStore','https://store.hp.com/mx-es','https://www.lenovo.com/fr','https://www.insight.com/en-US','https://store.hp.com/FranceStore#commercial','https://www.lenovo.com/fr#commercial','https://www.cdw.com','https://www.lenovo.com/gb#commercial','https://store.hp.com/UKStore#commercial','https://www.lenovo.com/de#commercial','https://store.hp.com/GermanyStore#commercial','https://www8.hp.com/jp','https://store.hp.com/us#commercial','https://www.lenovo.com/us#commercial','https://store.hp.com/UKStore','https://store.hp.com/us','https://www.asus.com/fr','https://store.asus.com/us','https://www.dell.com/en-us','https://store.acer.com/en-us','https://www.lenovo.com/us','https://www.lenovo.com/gb','https://www.lenovo.com/de'],
      columns_details:[],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      deviceMapper:{
        'laptop': 'PC',
        'desktop': 'Desktop'
      },
      filterRow: [],
      addFilter:false,
      filterKey: 'price',
      filterCondition: 'equals',
      filterVal1: '',
      filterVal2: '',
      websiteName: {
        "https://www.amazon.com": "Amazon US",
        "https://www.amazon.fr": "Amazon France",
        "https://www.amazon.co.it": "Amazon Italy",
        "https://www.amazon.es": "Amazon Spain",
        "https://www.amazon.co.uk": "Amazon UK",
        "https://www.amazon.de": "Amazon Germany",
        "https://www.harveynorman.com.au": "Harvey Norman AU",
        "https://www.bestbuy.com": "Best Buy US",
        "https://www.currys.co.uk": "Curry's UK",
        "https://www.costco.com": "Costco US",
        "https://www.walmart.com": "Walmart US",
        "https://store.hp.com/us": "HP US",
        "https://global.jd.com": "JD GC",
        "https://store.asus.com/us": "ASUS US",
        "https://www.dell.com/en-us": "Dell US",
        "https://www.dell.com/en-uk": "Dell UK",
        "https://store.acer.com/en-us": "Acer US",
        "https://store.hp.com/UKStore":"HP UK",
        "https://www8.hp.com/jp": "HP Japan",
        "https://www.lenovo.com/us":"Lenovo US",
        "https://www.lenovo.com/gb":"Lenovo UK",
        "https://www.lenovo.com/de":"Lenovo Germany",
        "https://www.mediamarkt.de": "MediaMarkt DE",
        "https://store.hp.com/us#commercial": "Commercial HP US",
        "https://www.lenovo.com/us#commercial": "Commercial Lenovo US",
        "https://www.lenovo.com/de#commercial": "Commercial Lenovo Germany ",
        "https://store.hp.com/GermanyStore#commercial": "Commercial HP Germany",
        "https://www.cdw.com":"CDW",
        "https://www.insight.com/en-US":"Insight",
        "https://www.lenovo.com/fr#commercial": 'Commercial Lenovo France',
        "https://store.hp.com/FranceStore#commercial": "Commercial HP France",
        "https://store.hp.com/UKStore#commercial": 'Commercial HP UK',
        "https://www.lenovo.com/gb#commercial": "Commercial Lenovo UK",
        "https://www.lenovo.com/fr": 'Lenovo France',
        'https://store.hp.com/mx-es': 'HP Mexico',
        "https://store.hp.com/FranceStore": 'HP France',
        "https://br-store.acer.com": 'Acer Brazil',
        "https://www.lenovo.com/au": 'Lenovo Australia',
        "https://s.lenovo.com.cn": 'Lenovo China',
        "https://www.asus.com/fr":'Asus France',
        "https://www.dell.com/en-au": "Dell Australia",
        "https://www.dell.com/ja-jp": "Dell Japan",
        'https://fmv.fccl.fujitsu.com': 'Fujitsu Japan',
        'https://www.nec-lavie.jp': 'NEC Japan',
        'https://www.hpstore.cn#commercial': 'Commercial HP China',
        'https://www.lenovo.com/jp#commercial': 'Commercial Lenovo Japan',
        'https://b2b.lenovo.com.cn#commercial': 'Commercial Lenovo China',
        'https://www8.hp.com/jp#commercial': 'Commercial HP Japan',
        'https://www.shi.com': 'SHI',  
        'https://www.connection.com': 'PC Connection',  
        'https://www.bechtle.com': 'Bechtle',
        'https://www.technoworld.com': 'TechnoWorld',
        'https://www.inmac-wstore.com': 'Inmac',
        "https://www.dustin.no": "Dustin Nordics Norway",
        "https://www.dustin.se": "Dustin Nordics Sweden",
        "https://www.dustin.fi": "Dustin Nordics Finland",
        "https://www.dustin.dk": "Dustin Nordics Denmark",
      },
      user: '',
      showDataEditForm: false,
      editFormData: {},
      formDataFields: [
        {label: 'Location', field: 'location'},
        {label: 'Name', field: 'product_name'},
        {label: 'Processor Type', field: 'processor_type'},
        {label: 'Processor Model', field: 'processor_model'}
      ],
      isDataEditable: false,
      editedTableData: {},
      selectedItemID: -1
    }
  },
  mounted()
  {
    if(localStorage.selected_category)
    {
      this.device = localStorage.selected_category
    }
    if(localStorage.reviewUserData)
    {
      this.user = JSON.parse(localStorage.reviewUserData).data.username;
    }
    this.website_details()
    this.initCols()
  },
  methods: {
    goToSOVDetailReport(){
      window.location = '#/sov-detail-report'
    },
    exportNow(){
      let self = this
      self.loader = true
      let payload = {}
      payload.website = this.selected_website
      payload.item_category = self.device
      payload.timestamp = self.date.startDate
      payload.website_name = self.websiteName[self.selected_website]
      const url = "/api/websites/sov_details/download"
      this.$http.post(url, payload).then(response => {
        self.loader = false
        window.location = response.body.data
        console.log('here')
      }, err => {
        self.loader = false
        console.log(err)
      });
    },
    getDataOrder(d){
      if((typeof(d)=='string') && (d.includes('.–')))
      {
        return '<span>' + d.replace('.–','') + '</span>'
      }
      return '<span>' + d + '</span>'

    },
    filterCancel(){
      let self = this
      $('#amdglobal-sov-detail-newTable').DataTable().destroy();
      this.addFilter = false
      this.filterRow = []
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  

    },
    filterRemove(i){
      this.filterRow.splice(i,1)
    },
    filterAddAction(){
      this.addFilter = true
      let obj = {}
      obj.filterKey = 'price'
      obj.filterCondition = 'equals'
      obj.val1 = ''
      obj.val2 = ''
      this.filterRow.push(obj)
    },
    filterAddMore(){
      let obj = {}
      obj.filterKey = 'price'
      obj.filterCondition = 'equals'
      obj.val1 = ''
      obj.val2 = ''
      this.filterRow.push(obj)

    },

    filterCheck(dataset){
      
      let operators = {
        'equals': function(a, b, c) { return a==b },
        'gt': function(a, b, c) { return a > b },
        'gte': function(a, b, c) { return a >= b },
        'lt': function(a, b, c) { return a < b },
        'lte': function(a, b, c) { return a <= b },
        'between': function(a, b, c) { 
          if(!c)
            return a >= b
          if(!b)
            return (a <= c)
          
          return ((a >= b)&&(a <= c)) },
      }
      for(let [fi, fd] of this.filterRow.entries()) 
      {
        if(!fd.val1)
        {
          if(fi==this.filterRow.length-1)
          {
            return true
          }
          else
          {
            continue
          }
        }

        if (typeof(dataset[fd.filterKey])=='string')
          dataset[fd.filterKey] = dataset[fd.filterKey].replace('.–','').replace('$','').replace(" ",'').replace(",",'').replace(",",'')
        dataset[fd.filterKey] = parseFloat(dataset[fd.filterKey])
        dataset[fd.val1] = parseFloat(dataset[fd.val1])  
        dataset[fd.val2] = parseFloat(dataset[fd.val2])  
        if (operators[fd.filterCondition](dataset[fd.filterKey], fd.val1, fd.val2  ) == false)
        {
          return false
        }
      }
      return true

    },
    filterApply(){
      let self = this
      $('#amdglobal-sov-detail-newTable').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(this.filterCheck(dataset))
        {
          this.rows_details.push(dataset)
        }
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
    initCols(){
      if(this.oem_websites.includes(this.selected_website))
      {
        
        this.columns_details = [ 
          {label: 'Location', field: 'location',sortable: false},
          {label: 'SKU', field: 'item_id',sortable: false},
          {label: 'Name', field: 'product_name',sortable: false},
          {label: 'Processor Type', field: 'processor_type',sortable: false},
          {label: 'Processor Model', field: 'processor_model',sortable: false}]
        
          if (this.user == 'admin') {
            this.columns_details.push({label: 'Link', field: 'link'})
          }

      }
      else
      {
        this.columns_details = [  {label: 'Rank', field: 'order'},
          {label: 'Page', field: 'page'},
          {label: 'Brand', field: 'brand'},
          {label: 'Name', field: 'product_name',sortable: false},
          {label: 'Processor', field: 'processor',sortable: false},
          {label: 'Processor Type', field: 'processor_type',sortable: false},
          {label: 'Processor Model', field: 'processor_model',sortable: false},
          {label: 'GPU', field: 'gpu_type',sortable: false},
          {label: 'Price', field: 'price',sortable: false},
          {label: 'Offer', field: 'offer',sortable: false},
          {label: 'Reviews', field: 'reviews'},
          {label: 'Ratings', field: 'ratings'}]
        
          if (this.user == 'admin') {
            this.columns_details.push({label: 'Link', field: 'link'})
          }

      }
      
     

    },
    backToSov()
    { 
      window.location = '#/sov'

    },
    showHeroChange(){
      let self = this
      $('#amdglobal-sov-detail-newTable').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      $('#amdglobal-sov-detail-newTable').DataTable().destroy();
      this.initCols()
      localStorage.selected_SOVWebsite = this.selected_website
      localStorage.selected_category = this.device
      this.website_details();
      this.isDataEditable = false;
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      let payload = { 
        "website": this.selected_website,
        "timestamp":this.date.startDate,
        "item_category": this.device
      }
      const url = "/api/websites/sov_details"
      this.$http.post(url, payload).then(response => {
        for (let [idx, ds] of  response.body.data.entries())
        {
          if(ds.product_name) ds.product_name = ds.product_name.replace('"','\'').replace('&amp;','&')
       
          if(ds.processor_type.indexOf('amd')!=-1) ds.processor_type = ds.processor_type.replace('amd','AMD')
          
          if(ds.location) ds.location = ds.location.replace('"', '\'')
         
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
        console.log(err)
        console.log('err')
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
      if (this.date.startDate2)
        this.date.startDate2 = moment(this.date.startDate2).format('YYYY-MM-DD')
    },
    processEditableTableData(rowData, id){
      if(id === this.selectedItemID) this.isDataEditable = false;
        else this.isDataEditable = true;
      // console.log(this.editedTableData);
      if(this.isDataEditable)
      {
        this.selectedItemID = id;
        this.editedTableData = {...rowData}
      }else{
        this.selectedItemID = -1;
        this.editedTableData = [];
      }
    },

    postEditedTableData(id){
      if(this.selectedItemID !== id){
        console.log('wrong save button');
        return false
      }
      const url = '/api/websites/update_sov_details_results';
      const payload = {
        "data": this.editedTableData,
        "section": "sov_details"
      }
      console.log(payload);
      this.$http.post(url, payload).then(response => {
        const res = response.body.data
        console.log(res)
        this.$bvToast.toast(`${res.summary[0].summary}`, {
          autoHideDelay: 5000,
          variant: res.status? "success" : "danger",
        });
        this.$nextTick(() => {
          this.refresh();
        })
      }, err => {
        this.isDataEditable = false;
        console.log(err)
      });
    },
    
    initDt2(){
      let self = this
      $('#amdglobal-sov-detail-newTable').DataTable({
        language: { 
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: ""
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_"
        },
        // dom: '<"top">frt<"bottom"li>p<"clear">',
        pagingType: 'full_numbers',
        // info: false,
        autoWidth: "false",
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
             
                var select = $('<select><option value="">All</option></select>')
                .appendTo( $(column.footer()).empty() )
                .on( 'change', function () {
                    var val = $.fn.dataTable.util.escapeRegex(
                        $(this).val()
                    );      
    
                    column
                        .search( val ? '^'+val+'$' : '', true, false )
                        .draw();
                } );
                let arr = []    
                let sortedArr = []
                column.data().unique().sort().each( function ( d, j ) {
                  var myVal = $(d).text()
                  arr.push(myVal)
                } ); 
                  
                sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
                
                for (let [idx, ds] of sortedArr.entries())
                {
                  select.append( '<option value="'+ds+'">'+ds+'</option>' )
                } 
          } );
        }
      });
      var search = require('../../public/Icons_SVG/Search.svg')
      $("#amdglobal-sov-detail-newTable_filter > label > input").attr("placeholder", "Search");
      $("#amdglobal-sov-detail-newTable_filter > label").append(`<div><img src='${search}' /></div>`);
      $("#amdglobal-sov-detail-newTable_length > label > select").removeClass();
    }
  }
}

</script>

<style>
#amdglobal-sov-detail-newTable_filter > label{
  display: flex;
  flex-direction: row;
  justify-content: end;
}
#amdglobal-sov-detail-newTable_filter input{
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}
#amdglobal-sov-detail-newTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}
#amdglobal-sov-detail-newTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}
#amdglobal-sov-detail-newTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
#amdglobal-sov-detail-newTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
#amdglobal-sov-detail-newTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}
#amdglobal-sov-detail-newTable_filter div{
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}
#amdglobal-sov-detail-newTable_filter img{
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#amdglobal-sov-detail-newTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}
#amdglobal-sov-detail-newTable_info{
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}
#amdglobal-sov-detail-newTable_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}
#amdglobal-sov-detail-newTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}
#amdglobal-sov-detail-newTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
  margin: 0;
}
#amdglobal-sov-detail-newTable_length select {
  width: 30px;
  height: 100%;
  text-align-last:center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background: none !important;
  color: var(--primary_brand-80);
}
#amdglobal-sov-detail-newTable_paginate .page-link{
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}
#amdglobal-sov-detail-newTable_paginate ul.pagination li.active{
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}
#amdglobal-sov-detail-newTable{
  border-radius: 20px 20px 0 0;
}
#amdglobal-sov-detail-newTable .thead-normal,#amdglobal-sov-detail-newTable .thead-normal tr,#amdglobal-sov-detail-newTable .thead-normal > tr > th:first-child{
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}
#amdglobal-sov-detail-newTable .thead-normal > tr > th:last-child{
  border-radius: 0 21px 0 0;
}
#amdglobal-sov-detail-newTable .thead-normal > tr > th{
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 8px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}
#amdglobal-sov-detail-newTable .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}
#amdglobal-sov-detail-newTable .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}
#amdglobal-sov-detail-newTable th select {
    background-color: #fff !important;
    filter: brightness(99%);
    border: 1px solid #b1b1b1 !important;
    width: 100%;
    color: var(--primary_brand-60);
    font-size: 10px;
    border-radius: 7px;
    height: 33px;
}
#amdglobal-sov-detail-newTable tfoot th{
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}
#amdglobal-sov-detail-newTable tfoot th:first-child{
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}
#amdglobal-sov-detail-newTable tbody td{
  border-right: 1px solid var(--base_color-20) 
  !important;
  border-bottom: 1px solid var(--base_color-20) 
  !important;

  font-size: 13px !important;
  font-family: 'Heebo', sans-serif !important;
}
#amdglobal-sov-detail-newTable tbody td:first-child{
  border-left: 1px solid var(--base_color-20) !important;
}
#amdglobal-sov-detail-newTable .even td{
  /* background-color: var(--base_color-5) !important; */
}
#amdglobal-sov-detail-newTable .odd td{
  /* background: #fff !important;
  filter: brightness(110%); */
}

/* #amdglobal-sov-detail-newTable_wrapper .bottom{
  margin: -30px;
} */
#amdglobal-sov-detail-newTable_wrapper > .row:last-child{
  margin-bottom: 15px;
}
#amdglobal-sov-detail-newTable_wrapper .scrolledDataTable{
  border-left: none;
  border-right: none;
}
#amdglobal-sov-detail-newTable_wrapper .scrolledDataTable::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
	border-radius: 10px;
	background: var(--base_color-10);
}

#amdglobal-sov-detail-newTable_wrapper .scrolledDataTable::-webkit-scrollbar
{
  height: 10px;
}

#amdglobal-sov-detail-newTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background: var(--base_color-80);
}
#amdglobal-sov-detail-newTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover
{
	background: var(--base_color);
}
</style>


<style scoped>
#sovdetailed {
  font-family: "Poppins", sans-serif !important;
}
.saveBtn
{
  background-color: #b4ffb3;border-radius:0;height: 30px;border: none;width:60px
}
.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
}
.exportButtonHover:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}
select {
  font-family: "Poppins", sans-serif;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
  /* border: 1.7px solid var(--primary_brand); */
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}
.navigationButton:hover {
  background: var(--accent_color-80);
}

.form-control{
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.export-btn{
  margin-right: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 15px;
}
.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

/* ---------- pre-revamp styles ----------- */

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:9
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
input.filval,button.filval{
  border-radius: 0;
  padding: 6px;
  height: 30px;

}
input.filval
{
  padding-top:5px;
}
button.filval
{
  padding-top:3px
}
.filter .row{
  justify-content: center;
}
.filter select, input.filval
{
  border:1px solid silver
}


</style>
